import { DependencyList, EffectCallback, useEffect } from 'react';

export const useOnParameterUpdate = (effect: EffectCallback, ...parameter: DependencyList): void => useEffect(effect, [ ...parameter ]);
